module.exports = __webpack_public_path__ + "3ec1ca6930dedc8e46e6d92f1a04d49f.png";